import React from "react";
import loadable from "@loadable/component";
const LoadableComponent = loadable(() => import("./FAQView"));
export default function LoadableFAQView(props) {
    return React.createElement(LoadableComponent, { ...props });
}
